export default "__VITE_ASSET__51632907__"